import { str } from "@lit/localize";
//#region src/generated/locales/be.ts
var templates = {
	"pd.chat.input.placeholder": `Bericht schrijven …`,
	"pd.chat.input.submit": `Verzenden`,
	"pd.chat.item.srOther": str`${0}, ${1}:`,
	"pd.chat.item.srOwn": str`Ik, ${0}:`,
	"pd.chat.list.empty": `Nog geen berichten`,
	"pd.chat.list.label": `Berichtgeschiedenis`,
	"pd.chat.list.typing": `Antwoord wordt geschreven`,
	"pd.contact.address.title": `Adres`,
	"pd.contact.check.company": `Bedrijf`,
	"pd.contact.check.private": `Particulier`,
	"pd.contact.label.additional": `Adres toevoeging`,
	"pd.contact.label.btw": `BTW-nummer`,
	"pd.contact.label.city": `Plaats`,
	"pd.contact.label.company": `Bedrijfsnaam`,
	"pd.contact.label.email": `E-mail`,
	"pd.contact.label.firstName": `Voornaam`,
	"pd.contact.label.lastName": `Achternaam`,
	"pd.contact.label.phone": `Telefoon`,
	"pd.contact.label.propertyDate": `Datum van het pand`,
	"pd.contact.label.street": `Straat`,
	"pd.contact.label.streetNr": `Nr.`,
	"pd.contact.label.summary.propertyDate": str`Bouwjaar: ${0}`,
	"pd.contact.label.type": `Type`,
	"pd.contact.label.zip": `Postcode`,
	"pd.contact.property.year.selection": `Bouwjaar selecteren`,
	"pd.form.field.invalid.url": `Voer een geldige URL in (bijv. example.com)`,
	"pd.history.changes.details": str`${0} Details`,
	"pd.history.changes.many": str`${0} wijzigingen`,
	"pd.history.changes.one": `1 wijziging`,
	"pd.history.kind.created": `Aangemaakt`,
	"pd.history.kind.deleted": `Verwijderd`,
	"pd.history.kind.process": `Proces`,
	"pd.history.kind.restored": `Hersteld`,
	"pd.history.kind.updated": `Bewerkt`,
	"pd.history.list.empty": `Nog geen items`,
	"pd.history.list.loading": `Geschiedenis wordt geladen`,
	"pd.history.value.empty": `leeg`,
	"pd.mail.ccHint": `CC/BCC`,
	"pd.mail.details": `Details`,
	"pd.mail.list.empty": `Nog geen mails`,
	"pd.mail.list.loading": `Mails worden geladen`,
	"pd.mail.meta.attempts": `Pogingen`,
	"pd.mail.meta.endTime": `Afgerond`,
	"pd.mail.meta.error": `Fout`,
	"pd.mail.meta.replyTo": `Antwoorden aan`,
	"pd.mail.meta.to": `Ontvanger`,
	"pd.mail.resend": `Opnieuw verzenden`,
	"pd.mail.state.error": `Mislukt`,
	"pd.mail.state.pending": `Wachtend`,
	"pd.mail.state.processing": `Wordt verzonden`,
	"pd.mail.state.retry": `Nieuwe poging`,
	"pd.mail.state.success": `Verzonden`,
	"pd.mail.to": `aan`,
	"pd.markdown.link.apply": `Toepassen`,
	"pd.markdown.link.cancel": `Annuleren`,
	"pd.markdown.link.remove": `Verwijderen`,
	"pd.markdown.link.text": `Weergavetekst`,
	"pd.markdown.link.url": `Link`,
	"pd.rating.input.cancel": `Annuleren`,
	"pd.rating.input.errorText": `Voer een tekst in.`,
	"pd.rating.input.starsLabel": `Beoordeling (optioneel)`,
	"pd.rating.input.submit": `Beoordeling versturen`,
	"pd.rating.input.text": `Ervaringsverslag`,
	"pd.rating.item.showLess": `Minder tonen`,
	"pd.rating.item.showMore": `Meer tonen`,
	"pd.rating.item.source": `Bron`,
	"pd.rating.list.create": `Beoordeling schrijven`,
	"pd.rating.list.empty": `Nog geen beoordelingen`,
	"pd.rating.list.loading": `Beoordelingen worden geladen`,
	"pd.rating.overview.ariaAction": str`${0} — lijst tonen`,
	"pd.rating.overview.ariaRated": str`Beoordeling: ${0} van 5 sterren, ${1}`,
	"pd.rating.overview.count": str`${0} beoordelingen`,
	"pd.rating.overview.countMixed": str`${0} verslagen · ${1} met beoordeling`,
	"pd.rating.overview.countOne": `1 beoordeling`,
	"pd.rating.overview.empty": `Nog geen beoordelingen`,
	"pd.rating.overview.loading": `Beoordelingen worden geladen`,
	"pd.rating.stars.label": str`Beoordeling: ${0} van 5 sterren`,
	"pd.rating.stars.option": str`${0} van 5 sterren`,
	"pd.rating.stars.pickerLabel": `Beoordeling selecteren`,
	"pd.trash.by": str`door ${0}`,
	"pd.trash.delete": str`Definitief verwijderen (${0})`,
	"pd.trash.deleted": str`verwijderd ${0}`,
	"pd.trash.details": `Details`,
	"pd.trash.list.empty": `De prullenbak is leeg`,
	"pd.trash.list.loading": `Prullenbak wordt geladen`,
	"pd.trash.marked-count": str`${0} gemarkeerd`,
	"pd.trash.restore": str`Herstellen (${0})`,
	"pd.trash.row.mark": str`${0} markeren`,
	"pd.trash.select-all": `Alles markeren`,
	"pd.socialmedia.aria.label": `Social-Media-Profile`,
	"pd.socialmedia.empty": `Keine Einträge`,
	"pd.socialmedia.new.entry": `Neuer Eintrag`,
	"pd.socialmedia.placeholder": `Socialmedia eingeben...`,
	"pd.socialmedia.delete": `Eintrag löschen`,
	"pd.socialmedia.cancel": `Abbrechen`,
	"pd.socialmedia.save": `Speichern`,
	"pd.contact.label.website": `Website`,
	"pd.iconPicker.selectIcon": `Icon auswählen`,
	"pd.iconPicker.clearIcon": `Icon entfernen`,
	"pd.iconPicker.placeholder": `Icon auswählen...`,
	"pd.iconPicker.dialogLabel": `Icon auswählen`,
	"pd.iconPicker.search": `Suchen...`,
	"pd.iconPicker.noResults": `Nichts gefunden`,
	"pd.iconPicker.noIcon": `Kein Icon`,
	"pd.iconPicker.recent": `Zuletzt verwendet`
};
//#endregion
export { templates };
